
(($) => {

/* functionality pulled from original theme for submitting the contact form */

if( $('.contact_form').length ) {
    var is_sending = false;

    $('.contact_form').on('submit', function(e) {
        e.preventDefault();

        if (!is_sending) {
            //console.log("SHould be triggering")
            is_sending = true;
            var val_errors = false;

            $('.contact_input').each(function() {

                if ($(this).val() === '') {
                    $(this).addClass('error');
                    val_errors = true;
                } else {
                    $(this).removeClass('error');
                }
            });

            if (!val_errors) {
                var form_vals = $(this).serialize();
                // console.log(form_vals);
                $.ajax({
                    url: site_data.WP_AJAX + '?action=contact',
                    data: form_vals,
                    method: 'POST'
                }).done(function(ret) {
                    // messageSent();
                    if (!ret.success && ret.data && ret.data.error) {
                        alert("An error has occurred and we weren't able to send your message. Please give us a call at 877-398-3030.");
                    } else if (ret.success && ret.data && ret.data.message) {
                        
                        //hide form, show success
                        $('.contact-popup').addClass('hidden');
                        $('.contact-popup-thankyou').removeClass('hidden');

                        // Clear the form vals so it won't get double submitted
                        $('.contact_input').each(function() {
                            $(this).val('');
                        });

                    } else {
                        alert("An error has occurred and we weren't able to send your message. Please give us a call at 877-398-3030.");
                    }
                    is_sending = false;
                });
            }
            is_sending = false;
        }

    });
}

})(jQuery)